
import webingo_logo from "../resources/Webingo_logo.png";

export default function NotFound404() {
  return (
    <div className='notFoundPage' style={{height:"90vh", minWidth:"900px",width:"90%", margin:"5vh auto",backgroundColor:"whitesmoke", borderRadius:"20px"}} dir='rtl'>
        <div className="notFound_header" style={{display:"flex",flexDirection:"column", margin:"auto",width:"100%",height:"fit-content", alignItems:"center", justifyContent:"space-evenly"}}>
            <h1 style={{color:"rgba(30, 70, 130, 1)", fontSize:"70px", margin:"15vh auto 50px"}}>Page Not Found - 404</h1>
            <h3 style={{color:"rgba(30, 70, 130, 1)", fontSize:"30px"}}>Oops.. seems like something went wrong due to bad routing</h3>
            <h3 style={{color:"rgba(30, 70, 130, 1)", fontSize:"24px", margin:"0 auto 20px"}}>We suggest to go back to previous page and then refresh page</h3>
            <img src={webingo_logo} style={{width:"100px", borderRadius:"25px",margin:"20px auto 0"}} alt="webingo_logo"/>
        </div>
    </div>
  )
}
